import RouteOtherDatesSuggestions
    from "@RouteSuggestions/features/suggestedDates/components/RouteOtherDatesSuggestions";
import GetByTransferNoResultsNotification
    from "@SearchResults/features/banners/features/getByTransferBanner/components/GetByTransferNoResultsNotification";
import {useIsAircash} from "@Hooks/selector/useIsAircash";
import {SearchResponseType} from "@SearchResults/types/SearchResponse.type";
import AccommodationBanner
    from "@SearchResults/features/banners/features/accommodationBanner/components/AccommodationBanner";
import React from "react";

interface NoResultsForDateProps {
    searchQuery: SearchResponseType,
}

function NoResultsForDate({searchQuery}: NoResultsForDateProps) {
    const {
        data: {
            result: {
                params,
                transfersData,
            },
            suggestionData,
        },
    } = searchQuery

    const isAircash = useIsAircash();

    return (
        <>
            <RouteOtherDatesSuggestions
                params={params}
                suggestionData={suggestionData}
            />
            {!isAircash && (
                <AccommodationBanner
                    params={params}
                />
            )}
            {!isAircash && (
                <GetByTransferNoResultsNotification
                    vehicles={transfersData?.vehicles}
                />
            )}
        </>
    )
}

export default NoResultsForDate